import { SITE_URL } from "@/lib/seo";

export function buildPrizeBondLandingHead(opts: {
  slug: string;
  title: string;
  description: string;
  denomination: number;
  howToName: string;
  howToSteps: { title: string; body: string }[];
  faqs: { q: string; a: string }[];
}) {
  const url = `${SITE_URL}/${opts.slug}`;
  const faq = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: opts.faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
  const howTo = {
    "@context": "https://schema.org",
    "@type": "HowTo",
    name: opts.howToName,
    totalTime: "PT1M",
    step: opts.howToSteps.map((s, i) => ({
      "@type": "HowToStep",
      position: i + 1,
      name: s.title,
      text: s.body,
      url: `${url}#how-to-check`,
    })),
  };
  const webApp = {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    name: `Rs. ${opts.denomination.toLocaleString("en-PK")} Prize Bond Checker`,
    url,
    applicationCategory: "FinanceApplication",
    operatingSystem: "Web Browser",
    offers: { "@type": "Offer", price: "0", priceCurrency: "PKR" },
    description: opts.description,
  };
  const breadcrumbs = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: SITE_URL },
      { "@type": "ListItem", position: 2, name: "Prize Bond", item: `${SITE_URL}/prize-bond` },
      { "@type": "ListItem", position: 3, name: `Rs. ${opts.denomination.toLocaleString("en-PK")}`, item: url },
    ],
  };
  return {
    meta: [
      { title: opts.title },
      { name: "description", content: opts.description },
      { property: "og:title", content: opts.title },
      { property: "og:description", content: opts.description },
      { property: "og:type", content: "website" },
      { property: "og:url", content: url },
    ],
    links: [{ rel: "canonical", href: url }],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(webApp) },
      { type: "application/ld+json", children: JSON.stringify(faq) },
      { type: "application/ld+json", children: JSON.stringify(howTo) },
      { type: "application/ld+json", children: JSON.stringify(breadcrumbs) },
    ],
  };
}
